module.exports = __webpack_public_path__ + "static/img/3a3a3acdd216f9fa19f31d7140b8dc3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsBanner.png
// module id = xFyg
// module chunks = 1